var render = function render(){var _vm=this,_c=_vm._self._c;return _c('upstream-sewage-wizard',{attrs:{"tool-name":"Volume","title-translation-path":"sidebar.upstreamSewage.volumeTitle"}})
}
var staticRenderFns = []

export { render, staticRenderFns }